import React from 'react';
import InputMask from 'react-input-mask';

export const CreateProfileForm = ({ handleOnChange, passwordError }) => {
	return (
		<div className="reach_form">
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="fullName">fullName</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="text"
							id="fullName"
							placeholder="Full name*"
							required
							name="fullName"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="userName">userName</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="text"
							id="userName"
							placeholder="User name*"
							required
							name="userName"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="dateOfBirth">dateOfBirth</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<InputMask
							id="dateOfBirth"
							className="form_field default_mod"
							type="text"
							mask="99/99/9999"
							placeholder="Date of Birth"
							name="dateOfBirth"
							onChange={handleOnChange}
						></InputMask>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="userEmail">email</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="email"
							id="userEmail"
							placeholder="Email*"
							required
							name="userEmail"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="password">password</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="password"
							id="password"
							placeholder="Password*"
							required
							name="password"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="confirmPassword">Confirm password</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="password"
							id="confirmPassword"
							placeholder="Confirm password*"
							required
							name="confirmPassword"
							onChange={handleOnChange}
						/>
						{passwordError ? <div className="error_message">{passwordError}</div> : null}
					</dd>
				</dl>
			</div>
		</div>

	);
}
export default CreateProfileForm;